import DownloadButton from "../DownloadButton";
import ProfilePlaceholder from "../../assets/svgIcons/ProfilePlaceholder.svg";
import "../../styles/components/transactionPrintLayouts/SupplierEvaluationFormLayout.css";

const pickValue = (source, keys, fallback = "") => {
  if (!source) return fallback;
  for (const key of keys) {
    const value = source[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return value;
    }
  }
  return fallback;
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const isChecked = (value) => {
  if (value === null || value === undefined) return false;
  const norm = String(value).trim().toLowerCase();
  return ["1", "true", "yes", "y"].includes(norm);
};

const Cb = ({ checked }) => (
  <div className={`sef-cb${checked ? " sef-cb--checked" : ""}`} />
);

const CbRow = ({ label, subLabel, checked }) => (
  <div className="sef-cb-row">
    <Cb checked={checked} />
    <span className="sef-cb-label">
      {label}
      {subLabel && <span className="sef-cb-sub">{subLabel}</span>}
    </span>
  </div>
);

export const SupplierEvaluationFormLayout = ({
  headDetails = {},
  companyData = {},
}) => {
  let organisationData = {};
  try {
    organisationData = JSON.parse(localStorage.getItem("organisation") || "{}");
  } catch (_) {}

  const orgName =
    organisationData.name ||
    organisationData.organisation_name ||
    "FINE PUNCH FAB PVT LTD";
  const orgLogo = organisationData.logo_url || ProfilePlaceholder;

  const tranNo = pickValue(headDetails, ["tran_no", "transaction_no"]);
  const date = formatDate(pickValue(headDetails, ["date", "created_at"]));
  const supplier = pickValue(headDetails, [
    "supplier",
    "supplier_name",
    "company_name",
  ]);
  const supplierId = pickValue(headDetails, ["supplier_id", "supplier_code"]);
  const location = pickValue(headDetails, ["location"]);
  const phone = pickValue(headDetails, ["phone", "company_phone"]);
  const evaluatedBy = pickValue(headDetails, [
    "evaluated_by",
    "evaluated_by_name",
  ]);

  const customerRequiredSupplier = isChecked(
    pickValue(headDetails, ["customer_required_supplier"]),
  );
  const soleSource = isChecked(pickValue(headDetails, ["sole_source"]));
  const qualityAppearsAdequate = isChecked(
    pickValue(headDetails, ["quality_appears_adequate"]),
  );
  const deliveryAvailability = isChecked(
    pickValue(headDetails, ["delivery_availability"]),
  );
  const referencesVerified = isChecked(
    pickValue(headDetails, ["references_verified"]),
  );
  const qualityManagement = isChecked(
    pickValue(headDetails, ["quality_management"]),
  );
  const pricingValue = isChecked(
    pickValue(headDetails, ["Pricing_value", "pricing_value"]),
  );
  const responsiveness = isChecked(pickValue(headDetails, ["responsiveness"]));
  const resultsOfEvaluation = isChecked(
    pickValue(headDetails, ["results_of_evaluation"]),
  );
  const supplierIsCapable = isChecked(
    pickValue(headDetails, ["supplier_is_capable"]),
  );
  const supplierSurveyResults = isChecked(
    pickValue(headDetails, ["supplier_survey_results"]),
  );
  const resultsOfOnSite = isChecked(
    pickValue(headDetails, ["results_of_on_site"]),
  );
  const other = pickValue(headDetails, ["other"]);
  const notes = pickValue(headDetails, ["notes"]);

  const refNo = "FP/F/PUR/02";
  const revNo = "01";
  const revDate = "30-07-2025";

  return (
    <div className="sef-page" id="sef-print-root">
      <div className="sef-card">
        {/* ── Header ── */}
        <div className="sef-header">
          <div className="sef-header-top">
            <img src={orgLogo} alt="Company Logo" className="sef-logo" />
            <span className="sef-org-name">{orgName}</span>
          </div>
          <div className="sef-title-box">SUPPLIER EVALUATION FORM</div>
        </div>

        {/* ── Fields (underline style) ── */}
        <div className="sef-fields">
          {/* Row 1: Supplier ID Code | Date */}
          <div className="sef-field-row">
            <div className="sef-field">
              <span className="sef-field-label">
                Supplier ID Code (if known)&nbsp;:
              </span>
              <span className="sef-field-value">{supplierId}</span>
            </div>
            <div
              className="sef-field"
              style={{ flex: "0 0 auto", minWidth: 160 }}
            >
              <span className="sef-field-label">Date:</span>
              <span className="sef-field-value" style={{ minWidth: 100 }}>
                {date}
              </span>
            </div>
          </div>

          {/* Row 2: Supplier */}
          <div className="sef-field-row">
            <div className="sef-field">
              <span className="sef-field-label">Supplier:</span>
              <span className="sef-field-value">{supplier}</span>
            </div>
          </div>

          {/* Row 3: Location | Phone */}
          <div className="sef-field-row">
            <div className="sef-field">
              <span className="sef-field-label">Location:</span>
              <span className="sef-field-value">{location}</span>
            </div>
            <div
              className="sef-field"
              style={{ flex: "0 0 auto", minWidth: 200 }}
            >
              <span className="sef-field-label">Phone:</span>
              <span className="sef-field-value" style={{ minWidth: 120 }}>
                {phone}
              </span>
            </div>
          </div>

          {/* Row 4: Evaluated by */}
          <div className="sef-field-row">
            <div className="sef-field" style={{ maxWidth: "55%" }}>
              <span className="sef-field-label">Evaluated by:</span>
              <span className="sef-field-value">{evaluatedBy}</span>
            </div>
          </div>
        </div>

        {/* ── Italic note ── */}
        <div className="sef-italic-note">
          If Part I criteria is met, the Part II criteria is optional.
        </div>

        {/* ── Part I ── */}
        <div className="sef-part-box">
          <div className="sef-part-title">Part I</div>
          <CbRow
            label="Customer required Supplier"
            checked={customerRequiredSupplier}
          />
          <CbRow label="Sole Source" checked={soleSource} />
        </div>

        {/* ── Part II ── */}
        <div className="sef-part-box">
          <div className="sef-part-title">Part II</div>
          <div className="sef-part-note">
            Evaluator: check the boxes below for each criteria you have
            evaluated.&nbsp; Attach evidence where indicated.&nbsp;
            <em>
              At least <strong>three</strong> criteria must be checked.
            </em>
          </div>

          <CbRow
            label="Quality appears adequate"
            checked={qualityAppearsAdequate}
          />
          <CbRow
            label="Delivery availability and terms are adequate"
            checked={deliveryAvailability}
          />
          <CbRow label="References verified" checked={referencesVerified} />
          <CbRow
            label="Quality management system certification to ISO 9001 or equivalent."
            subLabel="Attach a copy of certificate."
            checked={qualityManagement}
          />
          <CbRow label="Pricing & value" checked={pricingValue} />
          <CbRow label="Responsiveness" checked={responsiveness} />
          <CbRow
            label="Results of evaluation of sample parts or materials"
            checked={resultsOfEvaluation}
          />
          <CbRow
            label="Supplier is capable of meeting regulatory concerns"
            checked={supplierIsCapable}
          />
          <CbRow
            label="Supplier survey results"
            subLabel="Attach completed survey."
            checked={supplierSurveyResults}
          />
          <CbRow
            label="Results of on-site audit"
            subLabel="Attach completed audit report."
            checked={resultsOfOnSite}
          />

          {/* Other */}
          <div className="sef-other-row">
            <Cb checked={other && other.trim().length > 0} />
            <span style={{ fontWeight: 600, whiteSpace: "nowrap" }}>
              Other:
            </span>
            <span className="sef-other-line">{other}</span>
          </div>

          {/* Notes inside Part II */}
          <div className="sef-notes-label">NOTES:</div>
          <div className="sef-notes-value">{notes}</div>
        </div>

        {/* ── Footer ── */}
        <div className="sef-footer">
          <span>Ref. No. {refNo}</span>
          <span>Rev. No. {revNo}</span>
          <span>Rev. Date {revDate}</span>
        </div>

        <p className="invoice-system-generated-note">
          This is a system-generated document and does not require a signature.
        </p>

        {/* ── Download ── */}
        <div className="sef-actions">
          <DownloadButton
            tableData={null}
            fileName="supplier_evaluation_form"
            downloadFormats={["full-page-pdf"]}
            fullPageDownload={true}
            fullPageSelector="#sef-print-root"
          />
        </div>
      </div>
    </div>
  );
};
